import React from 'react'
import './index.css'

const Footer = () => {
	return (
		<footer>
			<div>
				<a href='/documents/Privacy.pdf'>Datenschutzerklärung</a>
				&nbsp;|&nbsp;
				<a href='/documents/Impressum__Text-6.0_(2025-01-05).pdf'>Impressum</a>
			</div>
		</footer>
	)
}

export default Footer
